export default __webpack_public_path__ + "static/media/icons8-audio-file.254e355f.svg";